import HeroSec from "../components/layout/HeroSec.js";
import img_st_7 from '../assets/imgs_optimized/img_st_7.webp';
import img_st_8 from '../assets/imgs_optimized/img_st_8.webp';
import img_st_9 from '../assets/imgs_optimized/img_st_9.webp';
import img_st_10 from '../assets/imgs_optimized/img_st_10.webp';
import bg_global from '../assets/imgs_optimized/bg_6.webp';

import FooterSection from "../components/layout/FooterSection.js";

function Research() {
    return (
        <>
            <HeroSec title="Investigación" />
            <div className='flex justify-center py-16 mt-16'>
                <div className='max-w-8xl relative w-full px-5 lg:px-24'>
                    <div className="flex justify-center items-center flex-wrap gap-16">
                        <div className="text-center max-w-[30%] flex items-center flex-col min-w-[15rem] shadow-2xl rounded-xl p-4">
                            <h3 className='text-3xl text-tertiary w-48 border gradient-border-b pb-1'>Lorem Ipsum</h3>
                            <p className="mt-3 text-xl text-secondary mt-8">Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetu adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <img src={img_st_7} alt="img_st_1" className="w-52 mt-8" />
                        </div>
                        <div className="text-center max-w-[30%] flex items-center flex-col min-w-[15rem] shadow-2xl rounded-xl p-4">
                            <h3 className='text-3xl text-tertiary w-48 border gradient-border-b pb-1'>Lorem Ipsum</h3>
                            <p className="mt-3 text-xl text-secondary mt-8">Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetu adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <img src={img_st_8} alt="img_st_1" className="w-52 mt-8" />
                        </div>
                        <div className="text-center max-w-[30%] flex items-center flex-col min-w-[15rem] shadow-2xl rounded-xl p-4">
                            <h3 className='text-3xl text-tertiary w-48 border gradient-border-b pb-1'>Lorem Ipsum</h3>
                            <p className="mt-3 text-xl text-secondary mt-8">Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetu adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <img src={img_st_9} alt="img_st_1" className="w-52 mt-8" />
                        </div>
                    </div>
                </div>
            </div>

            <div className='flex justify-center mt-16 relative py-12'>
                <img src={bg_global} alt="bg_global" className="absolute top-0 left-0 h-full w-full object-cover opacity-25 " style={{ zIndex: -1 }} />
                <div className='max-w-8xl relative w-full px-5 lg:px-24'>
                    <div className="flex justify-center items-center gap-20 flex-wrap">
                        <div className="min-w-[22rem] flex-1 text-center lg:text-left relative">
                        <h2 className='py-3 text-5xl text-primary border gradient-border-b pb-1'>Título lorem</h2>
                            <p className="text-secondary text-2xl mt-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis tristique diam id lacus consectetur, sed lacinia augue lobortis. Etiam viverra lacus nec metus auctor consectetur. Maecenas posuere arcu vel tortor ultricies commodo. Maecenas eget risus non ligula dignissim varius commodo eu ligula.Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <p className="text-secondary text-2xl mt-8">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis tristique diam id lacus consectetur, sed lacinia augue lobortis. Etiam viverra lacus nec metus auctor consectetur. Maecenas posuere arcu vel tortor ultricies commodo. Maecenas eget risus non ligula dignissim varius commodo eu ligula.Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                        <img src={img_st_10} alt="img_st_10" className="min-w-[18rem] rounded-full" />
                    </div>
                </div>
            </div>

            <FooterSection />
        </>
    )
}

export default Research;